
import React, { useState } from "react";
import AiLayout from "../../components/analyze/AiLayout";
import HistoryFilters from "../../components/ai-history/HistoryFilters";
import AnalysisCard from "../../components/ai-history/AnalysisCard";
import AnalysisModal from "../../components/ai-history/AnalysisModal";
import { History, TrendingUp, Filter } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

// Mock Data
const mockAnalyses = [
    {
        id: 1,
        analysis_type: "crypto",
        trading_type: "spot",
        image_url: "https://placehold.co/600x400/1e293b/white?text=BTC+Chart",
        crypto_pair: "BTC/USDT",
        entry_price: 68500,
        take_profit_1: 71000,
        stop_loss: 67000,
        risk_level: "medium",
        confidence_score: 92,
        pattern_detected: "Bullish Flag",
        trading_direction: "BUY",
        strategy_type: "swing",
        created_date: new Date().toISOString(),
        expert_reasoning: "Strong bullish momentum confirmed by volume.",
        timeframe: "4H"
    },
    {
        id: 2,
        analysis_type: "stock",
        stock_code: "CIMB",
        stock_name: "CIMB Group Holdings",
        image_url: "https://placehold.co/600x400/1e293b/white?text=CIMB+Chart",
        current_price: 6.50,
        investment_recommendation: {
            action: "BUY",
            target_price: 7.20,
            stop_loss: 6.10,
            risk_level: "low",
            time_horizon: "Mid-term"
        },
        confidence_score: 89,
        created_date: new Date(Date.now() - 86400000).toISOString(),
        expert_reasoning: "Solid fundamental with technical breakout above resistance.",
        timeframe: "Daily",
        news_analysis: [
            { headline: "CIMB Strong Earnings", summary: "CIMB Group records strong profit growth in Q1 backed by loan growth.", source: "The Edge", date: "Yesterday" }
        ]
    }
];

export default function HistoryPage() {
    const [filters, setFilters] = useState({
        tradingType: "all",
        riskLevel: "all",
        resultStatus: "all",
        dateRange: "all"
    });

    const [selectedAnalysis, setSelectedAnalysis] = useState(null);

    // Filter Logic (Simplified)
    const filteredAnalyses = mockAnalyses.filter(analysis => {
        if (filters.tradingType !== "all") {
            if (filters.tradingType === 'stock' && analysis.analysis_type !== 'stock') return false;
            if (filters.tradingType !== 'stock' && analysis.trading_type !== filters.tradingType && analysis.analysis_type !== filters.tradingType) return false;
        }
        // Add other filters logic here as needed
        return true;
    });

    return (
        <AiLayout>
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-white mb-2 flex items-center gap-3">
                    <History className="w-8 h-8 text-blue-400" />
                    Analysis History
                </h1>
                <p className="text-slate-400">
                    Track performance and AI analysis results here.
                </p>
            </div>

            <div className="mb-6">
                <HistoryFilters filters={filters} onFiltersChange={setFilters} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <AnimatePresence>
                    {filteredAnalyses.length > 0 ? (
                        filteredAnalyses.map((analysis) => (
                            <AnalysisCard
                                key={analysis.id}
                                analysis={analysis}
                                onClick={() => setSelectedAnalysis(analysis)}
                            />
                        ))
                    ) : (
                        <div className="col-span-full text-center py-12">
                            <div className="w-16 h-16 bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Filter className="w-8 h-8 text-slate-500" />
                            </div>
                            <h3 className="text-xl font-semibold text-white mb-2">Tidak ada analisis ditemukan</h3>
                            <p className="text-slate-400">Coba ubah filter pencarian Anda</p>
                        </div>
                    )}
                </AnimatePresence>
            </div>

            <AnalysisModal
                analysis={selectedAnalysis}
                onClose={() => setSelectedAnalysis(null)}
                onResultUpdate={() => console.log("Result updated")}
            />
        </AiLayout>
    );
}
